import { createContext, useContext, useEffect, useState } from "react";
import api, { TOKEN_KEY, limpiarSesionLocal } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        limpiarSesionLocal();
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    // Higiene en equipo compartido: al entrar un usuario nuevo NO queda nada del anterior.
    limpiarSesionLocal();
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    limpiarSesionLocal();
    setUser(false);
  };

  const aplicarToken = (token, nuevoUser) => {
    localStorage.setItem(TOKEN_KEY, token);
    if (nuevoUser) setUser(nuevoUser);
  };

  const isExternal = !!user && user.actor_type === "external";
  const isSupervisor = !!user && !isExternal && user.role === "supervisor";
  const isInstitucionalAdmin = isExternal && user.role === "institucional_admin";
  const permissions = (user && user.permissions) || [];
  const can = (p) => (isExternal ? permissions.includes(p) : !!user);

  return (
    <AuthContext.Provider
      value={{ user, ready, login, logout, aplicarToken, isSupervisor, isExternal,
               isInstitucionalAdmin, permissions, can }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
